import React, { forwardRef } from 'react';
import styled from 'styled-components';

type OwnProps = React.SVGProps<SVGSVGElement>;

const DeliveryLarge = styled.svg`
  fill: none;
  width: 104px;
  height: 104px;
`;

const DeliveryLargeIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <DeliveryLarge
    {...props}
    ref={ref}
    viewBox="0 0 105 104"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.8023 33.4358C34.1564 33.1536 34.5958 33 35.0486 33H45.7146C46.1946 33 46.6586 33.1726 47.0219 33.4864L54.4155 39.8721L61.1126 41.8826C62.3813 42.2635 63.25 43.4313 63.25 44.7559V48.2654C63.25 49.2234 62.4734 50 61.5154 50H59.178C59.2254 50.3001 59.25 50.6079 59.25 50.9215V51H57.25V50.9215C57.25 48.7706 55.4741 47 53.2501 47C51.026 47 49.2502 48.7706 49.2502 50.9215L49.2502 50.924L49.25 50.991L47.25 50.9861L47.2502 50.9215V50.9202C47.2502 50.607 47.2749 50.2997 47.3222 50H37.1787C37.2223 50.2773 37.2465 50.5612 37.2496 50.8502H37.25V50.916H35.25C35.25 48.7692 33.4752 47 31.25 47C29.0248 47 27.25 48.7692 27.25 50.916V51H25.25V50.916C25.25 50.6042 25.2744 50.2983 25.3213 50H21.25C20.1454 50 19.25 49.1046 19.25 48V42.48C19.25 41.0021 20.3263 39.7444 21.7865 39.5161L27.242 38.663L33.8023 33.4358ZM48.0294 48C49.0635 46.2046 51.0203 45 53.2501 45C55.4799 45 57.4367 46.2046 58.4707 48H61.25V44.7559C61.25 44.3144 60.9604 43.9251 60.5375 43.7982L53.8404 41.7877C53.5708 41.7067 53.3213 41.5697 53.1082 41.3857L45.7146 35L35.0486 35L28.4883 40.2272C28.2169 40.4434 27.8939 40.5853 27.551 40.639L22.0955 41.4921C21.6088 41.5682 21.25 41.9874 21.25 42.48V48H26.0276C27.0614 46.2045 29.0195 45 31.25 45C33.4805 45 35.4386 46.2045 36.4724 48H48.0294Z"
      fill="#00AED9"
    />
    <path
      d="M77.25 39H87.2448C89.2765 39.0605 92.75 40 93.6946 43.6495L94.7228 49.2364C94.7619 49.4485 94.8685 49.6424 95.0267 49.789L96.9296 51.552C97.1339 51.7412 97.25 52.0071 97.25 52.2855V62.9645C97.25 64.069 96.3546 64.9644 95.25 64.9644H88.25M7.25 53L52.6274 64.9344C52.7104 64.9562 52.7959 64.9673 52.8817 64.9673H77.25V36.3491H74.0209C73.5355 36.3491 73.1202 36.6977 73.036 37.1758L70.3963 52.1733C70.3121 52.6514 69.8968 53 69.4114 53H7.25Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M94.3784 49.0635H87.4722C86.3676 49.0635 85.4722 48.168 85.4722 47.0635V39.3135"
      stroke="#00619E"
      strokeWidth="2"
    />
    <circle cx="83.75" cy="65.5" r="5.5" stroke="#00619E" strokeWidth="2" />
    <circle cx="83.75" cy="65.5" r="1.5" stroke="#00619E" strokeWidth="2" />
    <circle cx="35.75" cy="65.5" r="1.5" stroke="#00619E" strokeWidth="2" />
    <path
      d="M33.3677 60C31.5231 60.9338 30.25 62.9182 30.25 65.2153C30.25 68.4101 32.7124 71 35.75 71C38.7876 71 41.25 68.4101 41.25 65.2153C41.25 63.8747 40.8164 62.6406 40.0887 61.6597"
      stroke="#00619E"
      strokeWidth="2"
    />
  </DeliveryLarge>
));

export default DeliveryLargeIcon;
